import React from 'react';
import { TriggerProps } from './trigger-components';

export const renderTriggerPlaceholderOrValue = (
  props: TriggerProps,
): JSX.Element => {
  const { isMulti, value, components } = props;
  const { TriggerPlaceholder, MultiValueTrigger, SingleValueTrigger } =
    components;
  const hasValue = isMulti ? Array.isArray(value) && value.length > 0 : value;

  if (!hasValue) {
    return <TriggerPlaceholder {...props} />;
  }

  return isMulti ? (
    <MultiValueTrigger {...props} />
  ) : (
    <SingleValueTrigger {...props} />
  );
};
